import React from 'react';
import PermButton from '../../core/utils/PermButton';
import { Table } from 'antd';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
  selectFilteredVendors,
  selectVendorLoading,
  selectfetchVendorLoading,
} from './store/selectors';
import { deleteVendor } from './store/slice';
import LoadingSpinner from '../../InitialPage/Sidebar/LoadingSpinner';



const VendorTable = ({ onEditVendor }) => {
  const dispatch = useDispatch();
  const { filteredData, isLoading, isFetchDataLoading } = useSelector(state => ({
    filteredData: selectFilteredVendors(state),
    isLoading: selectVendorLoading(state),
    isFetchDataLoading: selectfetchVendorLoading(state),
  }));

  const handleEditClick = (record) => {
    if (onEditVendor) {
      onEditVendor(record);
    }
  };

  const handleDeleteClick = id => {
    dispatch(deleteVendor(id));
  };

  const columns = [
    {
      title: 'Vendor Name',
      dataIndex: 'vendorName',
      sorter: (a, b) => a.vendorName?.localeCompare(b.vendorName) || 0,
    },
    {
      title: 'Location',
      dataIndex: 'location',
      sorter: (a, b) => a.location?.localeCompare(b.location) || 0,
    },
    {
      title: 'Contact Person',
      dataIndex: 'contactPerson',
      sorter: (a, b) => a.contactPerson?.localeCompare(b.contactPerson) || 0,
    },
    {
      title: 'Action',
      fixed: 'right',
      width: 100,
      render: (text, record) => (
        <div className="d-flex align-items-center">
          <PermButton perm="MASTERS.VENDOR.EDIT">
            <Link
              to="#"
              className="btn btn-sm btn-white text-success me-2"
              onClick={() => handleEditClick(record)}
            >
              <i className="far fa-edit me-1"></i>
            </Link>
          </PermButton>
          <PermButton perm="MASTERS.VENDOR.DELETE">
            <Link
              to="#"
              className="btn btn-sm btn-white text-danger me-2"
              onClick={() => handleDeleteClick(record.id)}
            >
              <i className="far fa-trash-alt me-1"></i>
            </Link>
          </PermButton>
        </div>
      ),
    },
  ];

  return (
    <div className="table-responsive">
      {(isLoading || isFetchDataLoading) && <LoadingSpinner />}
      <Table
        className="table table-center table-hover datatable"
        columns={columns}
        dataSource={filteredData}
        rowKey={record => record.id}
        pagination={{
          total: filteredData?.length,
          pageSize: 10,
          showSizeChanger: true,
          showTotal: (total, range) => `Showing ${range[0]} to ${range[1]} of ${total} entries`,
        }}
      />
    </div>
  );
};

export default VendorTable; 